import { render, staticRenderFns } from "./StartClaim.vue?vue&type=template&id=d9518560&lang=pug&"
import script from "./StartClaim.vue?vue&type=script&lang=js&"
export * from "./StartClaim.vue?vue&type=script&lang=js&"
import style0 from "./StartClaim.vue?vue&type=style&index=0&id=d9518560&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports